import { DrawingItem } from "src/js/types/DrawingItem";
import { drawingStore } from "../store";

export const duplicateGeometry = (id: DrawingItem["id"], zoom: number) => {
  const actions = drawingStore.reduxStore?.actions;
  const store = drawingStore.reduxStore?.store;
  if (!store || !actions) return;

  store.dispatch(actions.duplicateShapeById(id, zoom));
};
